import { connect } from "react-redux";
import { iconsMap } from "../../Utils/iconsMap";
import { ConfStyle } from "./style";
import { GetStorage } from "../../Utils/Storage";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { memo, useEffect, useRef, useState } from "react";
import {
  changeLiveTrackMapDrawerTabAction,
  clearStateAction,
  getMissionConfirmationAction,
  goToDriverMissionInfoAction,
} from "../../Store/Actions/PlanView/Actions";
import {
  Fade,
  Grid,
  Paper,
  Typography,
  ClickAwayListener,
} from "@material-ui/core";

import clsx from "clsx";
import Bell from "../../Assets/SVGs/Bell";

const ConfirmationNotification = (props) => {
  const { i18n } = useTranslation("translation", {
    keyPrefix: "Confirmation",
  });

  const classes = ConfStyle({
    dir: i18n.dir(),
  });

  const [OpenNotifBox, setOpenNotifBox] = useState(false);

  const Interval = useRef(null);

  useEffect(() => {
    if (GetStorage("optime_token")) {
      if (Interval.current) {
        clearInterval(Interval.current);
        Interval.current = null;
      }
      Interval.current = setInterval(() => {
        props.getMissionConfirmation();
      }, 15000);
    }
  }, []);

  if (!props.MissionConfirmation || !props.MissionConfirmation?.length) {
    return null;
  }

  const handleGoToDriverMission = (driver) => {
    props.changeLiveTrackTab(1);
    props.clearState("goToDriverMissionInfo");
    props.clearState("SingleMissionConfirmation");
    props.goToDriverMissionInfo(driver);
    props.history.push(`/map/live-tracking/all/${driver.planId}`);
  };

  return (
    <Grid className={classes.wrapper}>
      <ClickAwayListener onClickAway={() => setOpenNotifBox(false)}>
        <Grid
          onClick={() => {
            setOpenNotifBox(true);
          }}
        >
          <Grid className={classes.badge}>
            {props.MissionConfirmation?.length}
          </Grid>
          <Grid className={classes.bellWrapper}>
            <Bell />
          </Grid>
        </Grid>
      </ClickAwayListener>
      <Fade in={OpenNotifBox}>
        <Paper
          position="absolute"
          classes={{ root: classes.fadeRoot }}
          elevation={5}
        >
          {props.MissionConfirmation.map((driver, i) => (
            <Grid
              key={i}
              onClick={() => handleGoToDriverMission(driver)}
              className={clsx(classes.itemIcon, classes.item)}
            >
              <span style={{ position: "relative", bottom: -2 }}>
                {iconsMap["user"]()}
              </span>
              &nbsp; &nbsp;
              <Grid className={classes.driverInfoBox}>
                <Typography
                  className={classes.message}
                  style={{ fontSize: ".8rem" }}
                >
                  {driver.driverName || "Driver #" + driver.driverId}
                </Typography>
                <Typography
                  className={classes.message}
                  style={{ fontSize: driver.message ? ".8rem" : ".65rem" }}
                >
                  {driver.message || "No Message"}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Paper>
      </Fade>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    MissionConfirmation: state.view.MissionConfirmation.response,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMissionConfirmation: () => dispatch(getMissionConfirmationAction()),
    changeLiveTrackTab: (tab) => {
      dispatch(changeLiveTrackMapDrawerTabAction(tab));
    },
    goToDriverMissionInfo: (data) =>
      dispatch(goToDriverMissionInfoAction(data)),
    clearState: (state) => {
      dispatch(clearStateAction(state));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(withRouter(ConfirmationNotification)));
